import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toJS } from 'mobx';
import { DownloadRecord } from '../../types';
import moment from 'moment';
import { BookOpen, Calendar } from 'lucide-react';
import { Card } from '@/components/ui/card';

interface BookCardDownloadProps {
  download: DownloadRecord;
}

const BookCardDownload: React.FC<BookCardDownloadProps> = ({ download }) => {
  const navigate = useNavigate();
  const book = download.adverbook;

  const handlePress = () => {
    // toJS() deproxies MobX so React Router can clone the navigation state.
    navigate('/pdf-viewer', { state: { download: toJS(download) } });
  };

  // D2P returns absolute presigned URLs already.
  const coverUrl = book?.coverImage || '';

  return (
    <Card
      className="overflow-hidden active:scale-[0.98] transition-transform cursor-pointer"
      onClick={handlePress}
    >
      <div className="flex p-3 gap-3">
        <div className="w-20 h-28 rounded-lg overflow-hidden bg-muted flex-shrink-0">
          {coverUrl ? (
            <img
              src={coverUrl}
              alt={book?.title}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          ) : (
            <div className="w-full h-full bg-gradient-to-br from-secondary to-secondary/60 flex items-center justify-center">
              <BookOpen className="w-8 h-8 text-white/40" />
            </div>
          )}
        </div>
        <div className="flex-1 flex flex-col justify-center min-w-0">
          <h3 className="text-sm font-semibold text-foreground truncate">{book?.title || 'Unknown Book'}</h3>
          <p className="text-xs text-muted-foreground mt-0.5 truncate">{book?.authorName || 'Unknown Author'}</p>
          <div className="flex items-center gap-1 mt-2 text-muted-foreground">
            <Calendar className="w-3 h-3" />
            <span className="text-[10px]">
              {moment(download.createdAt).format('MMM DD, YYYY')}
            </span>
          </div>
        </div>
        <div className="flex items-center">
          <div className="w-8 h-8 bg-secondary/10 rounded-full flex items-center justify-center">
            <BookOpen className="w-4 h-4 text-secondary" />
          </div>
        </div>
      </div>
    </Card>
  );
};

export default BookCardDownload;
